import request from '@/utils/request'

// 订单列表（统一 POST，参数进 body：status/staff_id/keyword/start_date/end_date/unit_id/team_id/page/limit）
export function orderList(data) {
  return request.post('/order/index', data)
}

// 订单详情（GET query id）
export function orderDetail(id) {
  return request.get('/order/detail', { params: { id } })
}

// 创建订单（销售员工/管理员）
export function orderAdd(data) {
  return request.post('/order/add', data)
}

// 完成订单（仅管理员/队长；须无未完成账单）
export function orderFinish(id) {
  return request.post('/order/finish', { id })
}

// 转移订单（仅管理员；联动未完成账单业绩归属）
export function orderTransfer(id, staffId) {
  return request.post('/order/transfer', { id, staff_id: staffId })
}

// 删除订单（仅机构管理员；有关联协议/账单/分期/退款时拒绝）
export function orderDelete(id) {
  return request.post('/order/delete', { id })
}

// 修改订单基本信息（仅机构管理员，受保护）
export function orderEdit(data) {
  return request.post('/order/edit', data)
}

// 修改订单商品/价格（仅机构管理员，受保护）
export function orderEditProduct(data) {
  return request.post('/order/editProduct', data)
}

// 订单轨迹（时间线：订单创建/分期/账单/退款 全链路）
export function orderTrajectory(id) {
  return request.get('/order/trajectory', { params: { id } })
}

// 标记已加微信（回写关联线索 is_added=1，推广侧同步）
export function orderMarkWechat(id) {
  return request.post('/order/markWechat', { id })
}

// 标记已成交（回写关联线索 status=3+order_id，推广侧同步）
export function orderMarkDeal(id) {
  return request.post('/order/markDeal', { id })
}

// 可下单的已成交线索（新建订单带入，量账号即微信号）
export function orderDealLeads() {
  return request.post('/order/dealLeads')
}
